import { mapMutations, mapGetters, mapActions } from "vuex";
import {} from "@/store/mutation-types";

import timer from "@/components/timer/index.vue";
import StarRating from "vue-star-rating";
import moment from "moment";

export default {
    name: "promotion-product",
    props: ["product", "time"],
    data() {
        return {
            isShowTimer: false,
            discount: false,
            addToFavorite: false,
        };
    },
    components: {
        timer,
        StarRating,
    },
    computed: {
        ...mapGetters({
            basket: `basket/basket`,
            count: `basket/count`,
            popupFastBuy: `card/popupFastBuy`,
            isAuthenticated: `auth/isAuthenticated`,
            productLoading: "promotions/productLoading",
            favouriteList: "favorites/whichList",
        }),
        getUnit() {
            if (this.product.unit !== null) {
                return "/" + this.product.unit;
            }
        },
        getCurrentPrice() {
            if (this.product.sale_start) {
                let period = `${this.product.sale_start.slice(0, -8)},${this.product.sale_end.slice(0, -8)}`;
                let currentDate = new Date().toISOString().split("T")[0];
                let dates = period.split(",");
                let result = moment(currentDate).isBetween(dates[0], dates[1], null, "()");

                if (!result && this.product.discount_price === 0) {
                    return this.product.price;
                } else {
                    this.discount = true;
                    return this.product.discount_price;
                }
            } else {
                return this.product.price;
            }
        },
    },
    watch: {
        // '$route'(newVal) {
        //     if(newVal){
        // this.resetSkip()
        // this.fetchPromoList(this.$route.params.slug)
        // }
        // }
    },
    created() {
        // this.resetSkip()
        // this.fetchPromoList(this.$route.params.slug)
    },
    methods: {
        ...mapActions({
            removeFromFavourite: `favorites/REMOVE_PRODUCT_IN_FAVORITE`,
            fetchPromoList: `promotions/GET_PROMOTIONS_LIST`,
            addFavourite: `favorites/ADD_PRODUCT_TO_FAVORITE`,
            fetchNewPromoList: `promotions/GET_PROMOTIONS_CURRENT_LIST`,
        }),
        ...mapMutations({
            addBasket: `basket/ADD_ITEM_TO_BASKET`,
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            resetSkip: `promotions/RESET_SKIP`,
            resetLimit: `promotions/RESET_LIMIT`,
        }),
        addToBasket(product) {
            this.addBasket({
                min_price: this.product.min_price,
                select_count: this.count,
                select_price: product.discount_price ? product.discount_price : product.price,
                ...product,
            });
            this.$toasted.success(this.$t("successAddBasket"));
        },
        changePopup(status) {
            this.changeFastBuy({
                show: status,
                product_id: this.product.id,
                count: this.product.select_count ? this.product.select_count : 1,
            });
        },
        addToFavourite(product) {
            if (this.isAuthenticated) {
                let currentProduct = this.favouriteList.find(favorite => favorite.id === product.id);
                if (currentProduct) {
                    return this.removeItem(currentProduct);
                }
                this.addFavourite(product)
                    .then(() => {
                        this.addToFavorite = true;
                        this.$toasted.success(this.$t("successAddFavourites"));
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 422) {
                            console.log(this.validationErrors);
                        }
                    });
            } else {
                this.changePopupRegister({ show: true, isRedirect: false });
            }
        },
        removeItem(product) {
            this.removeFromFavourite(product)
                .then(() => {
                    this.$toasted.success(this.$t("successRemoveFromFavourites"));
                    this.addToFavorite = false;
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 422) {
                        console.log(this.validationErrors);
                    }
                });
        },
    },
};
